let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lELr1")).then(() => parcelRequire('5Kre9'));